import { motion } from "framer-motion";
import { STEPS } from "../../lib/content";
import { Kicker, Reveal } from "./Reveal";

export const Process = () => (
  <section id="postup" data-testid="process-section" className="py-24 md:py-36">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <Reveal>
        <Kicker>Postup</Kicker>
        <h2 className="mt-6 font-display text-4xl md:text-6xl font-semibold uppercase leading-[0.95]">Čtyři kroky<br /><span className="text-outline">k hostině</span></h2>
      </Reveal>
      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 border-t border-[var(--line)]">
        {STEPS.map((s, i) => (
          <motion.div key={s.n} data-testid={`step-${s.n}`}
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
            transition={{ delay: i * 0.12, duration: 0.8 }}
            className="group relative pt-10 pb-12 pr-8 lg:border-r border-b lg:border-b-0 border-[var(--line)] last:border-r-0 lg:pl-8 lg:first:pl-0">
            <span className="absolute top-0 left-0 lg:left-8 lg:group-first:left-0 h-[2px] w-0 bg-[var(--cyan)] transition-all duration-700 group-hover:w-24" />
            <span className="font-display text-6xl font-extrabold text-outline">{s.n}</span>
            <h3 className="mt-6 font-display text-xl uppercase font-semibold">{s.title}</h3>
            <p className="mt-3 text-[var(--muted)] leading-relaxed">{s.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
